module.exports = __webpack_public_path__ + "static/media/fvs_valve1_44.60018bc5.jpg";